<template>
  <v-card style="height:100%; padding-bottom:20px;">
    <v-card-title>{{ $t('aff.myBalance') }}</v-card-title>
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="card"
      :tile="true"
      class="mx-auto"
      width="100%"
    />
    <v-card-text
      v-if="!$apollo.loading && affStatus && totalEarned && userBalance"
    >
      <v-layout
        wrap
        justify-center
        class="internal_balnce text-no-wrap"
        :class="$vuetify.breakpoint.xs ? 'xs': ''"
        pt-10
      >
        <v-flex
          xs12
          md4
        >
          <b>{{ Math.ceil(getUser.aiv_balance) }}</b> {{ getBalance("AIV").currency }}
          <v-tooltip
            top
          >
            <template v-slot:activator="{ on }">
              <v-icon
                style="margin-top:-7px;"
                v-on="on"
              >
                mdi-information-outline
              </v-icon>
            </template>
            {{ $t('aff.platform') }}: {{ getBalance("AIV").credit }} {{ getBalance("AIV").currency }}<br>
            {{ $t('aff.wallet') }}: {{ getUser.aiv_balance - getBalance("AIV").credit }} {{ getBalance("AIV").currency }}
          </v-tooltip>
        </v-flex>
        <v-flex
          xs12
          md4
        >
          <b>{{ getBalance("USDT").credit }}</b> {{ getBalance("USDT").currency }}
        </v-flex>
        <v-flex
          xs12
          md4
        >
          <b>{{ getBalance("BTC").credit }}</b> {{ getBalance("BTC").currency }}
        </v-flex>
      </v-layout>
      <v-simple-table
        dense
        class="mt-2"
      >
        <thead>
          <tr>
            <th />
            <th class="text-left">
              USDT
            </th>
            <th class="text-left">
              BTC
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $t('aff.totalEarned') }}</td>
            <td>{{ totalEarned.usdt_total }}</td>
            <td>{{ totalEarned.btc_total }}</td>
          </tr>
          <tr>
            <td>{{ $t('aff.commPaied') }}</td>
            <td>{{ totalEarned.usdt_withdrawn }}</td>
            <td>{{ totalEarned.btc_withdrawn }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <!-- <v-layout
        v-if="affStatus.client !== null || affStatus.partner !== false"
        wrap
      >
        <v-flex
          xs12
          mt-4
          style="text-align:center;border:2px solid #f1f1f1;font-size:18px;"
        >
          {{ $t('aff.youAre') }}:
          <b
            v-if="affStatus.client !== null"
            class="text-positive"
          >{{ affStatus.client }} {{ $t('aff.client') }}</b>
          {{ affStatus.client !== null && affStatus.partner !== false ? $t('aff.and') : '' }}
          <b
            v-if="affStatus.partner !== false"
            class="text-primary"
          >{{ affStatus.partner ? $t('aff.andPartner') : '' }}</b>&nbsp;
          <b
            v-if="affStatus.rank !== null"
            class="text-error"
          >
            <v-icon style="margin:-12px 5px 0 0;">mdi-podium-bronze</v-icon>
            {{ affStatus.rank }}
          </b>
        </v-flex>
      </v-layout> -->
    </v-card-text>
    <!-- <v-flex
      v-if="getUser && !getUser.is_ibo"
      xs12
      text-right
    >
      <v-btn
        class="success"
        small
        @click="upgradeDialog = true"
      >
        {{ $t('toolbar.buyPackage') }}
      </v-btn>
    </v-flex> -->
  </v-card>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";

const USER_BALANCE_QUERY = require("@/graphql/queries/UserBalance.gql");
const TOTAL_EARNED_QUERY = require("@/graphql/queries/TotalEarned.gql");
const AFF_STATUS_QUERY = require("@/graphql/queries/AffStatus.gql");

export default {
  name: "RefBoard",
  data() {
    return {
      location: window.location.protocol + "//" + window.location.hostname,
      loading: false,
      btc_balance: 0,
      usdt_balance: 0,
      aiv_balance: 0
    };
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
  },
  beforeDestroy() {
    this.$apollo.queries.userBalance.stopPolling();
    this.$apollo.queries.totalEarned.stopPolling();
    this.$apollo.queries.affStatus.stopPolling();
  },
  methods: {
    ...mapMutations("user", ["updateUser"]),
    getBalance(currency) {
      return this.userBalance ? this.userBalance.wallet.find(o => o.currency == currency) : null;
    },
  },
  apollo: {
    userBalance: {
      query: USER_BALANCE_QUERY,
      fetchPolicy: "network-only",
      pollInterval: 30 * 1000
    },
    totalEarned: {
      query: TOTAL_EARNED_QUERY,
      fetchPolicy: "network-only",
      pollInterval: 30 * 1000
    },
    affStatus: {
      query: AFF_STATUS_QUERY,
      fetchPolicy: "network-only",
      pollInterval: 60 * 1000
    }
  }
};
</script>

<style lang="scss" >
.internal_balnce {
  .v-icon {
    font-size:18px;
  }
  &.xs {
    font-size: 12px !important;
    b {
      font-size: 16px !important;
    }
    .flex {
      padding: 0 !important;
    }
  }
  .flex {
    text-align: center;
    b {
      font-size: 22px;
    }
  }
}
</style>